import { ziggyGetRoute } from '@/router/ziggyGetRoute';

const checkBrowserAndGetRedirect = ({ changeRoute, continueRoute }) => {
	var ua = window.navigator.userAgent;
	let uaSubstrings = [
		'MSIE ',
		'Trident/',
		// 'Edge/',
		// 'Edg/',
		// 'EdgiOS/',
		'Opera/',
		'OPR/',
	];
	let incomp = (new RegExp(uaSubstrings.join("|")).test(ua));
	let changeUrl = ziggyGetRoute(changeRoute) || '';
	let onChange = window.location.pathname == changeUrl;

	if (onChange && !incomp && continueRoute) {
		return ziggyGetRoute(continueRoute);
	}
	else if (!onChange && incomp) {
		if (changeRoute) {
			return ziggyGetRoute(changeRoute);
		} else {
			console.error('Browser Incompatible. Chrome, Safari, Microsoft Edge, or Firefox recommended.');
			return false;
		}
	}
};

export {
	checkBrowserAndGetRedirect
};